import SEO from './components/SEO';

export default function LinusTseIntroductionPage() {
  return (
    <>
      <SEO
        title="Meet Linus Tse | Greyfield Data"
        description="Linus Tse explains the Snowflake, reporting, automation, and internal tool work he does with clients."
        type="website"
        url="https://www.greyfielddata.com/linus-tse-introduction"
        image="https://www.greyfielddata.com/images/linus-tse-linkedin-photo.jpeg"
        keywords={[
          'Linus Tse introduction',
          'Greyfield Data founder introduction',
          'data consultant introduction video',
          'automation consultant introduction',
        ]}
      />

      <div className="min-h-screen bg-slate-50 font-['Inter'] overflow-x-hidden">
        <section className="relative flex min-h-screen items-center overflow-hidden bg-slate-50 py-16 md:py-24">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(26,78,148,0.08),_transparent_42%)]" />

          <div className="relative mx-auto w-full max-w-4xl px-6">
            <div className="mb-10 text-center">
              <p className="mb-3 text-sm font-semibold uppercase tracking-[0.22em] text-[#1a4e94]">Meet Linus Tse</p>
              <h1 className="mb-4 text-4xl font-semibold leading-[1.1] tracking-tight text-slate-900 md:text-5xl">
                A quick introduction before we talk
              </h1>
              <p className="mx-auto max-w-2xl text-lg leading-relaxed text-slate-600">
                If you're watching this before a conversation, you'll get a quick sense of who I am, how I work, and
                the projects I take on.
              </p>
            </div>

            <div className="overflow-hidden rounded-[2rem] border border-slate-200 bg-slate-950 p-3 shadow-[0_30px_80px_rgba(15,23,42,0.16)]">
              <iframe
                className="aspect-video w-full rounded-[1.4rem] bg-black"
                src="https://www.youtube.com/embed/PZVZ3pipNbE?rel=0"
                title="Linus Tse introduction video"
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>

            <div className="mt-10 rounded-[1.75rem] border border-slate-200 bg-white px-6 py-7 text-center shadow-[0_12px_40px_rgba(15,23,42,0.05)] md:px-10">
              <p className="mx-auto max-w-3xl text-base leading-relaxed text-slate-600 md:text-lg">
                I work on Snowflake and reporting, plus the automations and internal tools around them. Most projects
                start with a report that takes too long, a number people don't trust, or data someone has to re-enter.
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
